/* eslint no-console: 0 */

import Vue from 'vue'
import Cookies from 'js-cookie'
import { provide } from 'vue'
import VueRouter from 'vue-router'
import { Line } from 'vue-chartjs';
import VueI18n from 'vue-i18n'
import App from '../app.vue'
import customers from './customers.vue'
import customer from './customer.vue'
import desktop from './desktop.vue'
import places from './places.vue'
import place from './place.vue'
import inspections from './inspections.vue'
import placeinspections from './place_inspections.vue'
import placeinstallations from './place_installations.vue'
import placeanalyses from './place_analyses.vue'
import placeinterventions from './place_interventions.vue'
import placeplans from './place_plans.vue'
import placerecommendations from './place_recommendations.vue'
import placeinspectionrecommendations from './place_inspection_recommendations.vue'
import LineChart from './linechart.vue'
import PestsChart from './pestschart.vue'
import PercentChart from './percentchart.vue'
import ColChart from './colchart.vue'
import ColChartInspections from './colchartinspections.vue'
import ColChartInspectionsQuantities from './colchartinspectionsquantities.vue'
import ColChartZonesInspectionsQuantities from './colchartzonesinspectionsquantities.vue'
import SumGraphQuantities from './sumgraphquantities.vue'
import ZonesInspectionsQuantities from './zoneinspectionsquantities.vue'
import AvgGraph from './avggraph.vue'
import StddGraph from './stddgraph.vue'
import DeviceGraph from './devicegraph.vue'
import installations from './installations.vue'
import installation from './installation.vue'
import interventions from './interventions.vue'
import protocols from './protocols.vue'
import plantcare from './plantcare.vue'
import substancepopup from './substancepopup.vue'
import intervention from './intervention.vue'
import interventiondosageedit from './intervention_dosage_edit.vue'
import interventionmaterialedit from './intervention_material_edit.vue'
import inspection from './inspection.vue'
import inspection_summary from './inspection_summary.vue'
import inspection_edit from './inspection_edit.vue'
import tasks from './tasks.vue'
import taskform from './taskform.vue'
import calendar from './calendar.vue'
import bases from './bases.vue'
import pest from './pest.vue'
import week from './week.vue'
import day from './day.vue'
import devices from './devices.vue'
import hamburger from './hamburger.vue'
import dev_type from './dev_type.vue'
import subplaces from './subplaces.vue'
import worker from './worker.vue'
import preloader from './preloader.vue'
import device_category from './device_category.vue'
import VLazyImage from "v-lazy-image/v2";
import substance from './substance.vue'
import subdevices from './subdevices.vue'
import material from './material.vue'
import settings from './settings.vue'
import maintenaces from './maintenaces.vue'
import pests from './pests.vue'
import targetpest from './targetpest.vue'
import modal from './modal.vue'
import substances from './substances.vue'
import selectpestquantities from './selectpestquantities.vue'
import selectpests from './selectpests.vue'
import recommendationeditor from './recommendationeditor.vue'
import inspector from './inspector.vue'
import propertyproblemmodal from './propertyproblemmodal.vue'
import reporter from './reporter.vue'
import dosageEditor from './dosageEditor.vue'
import dropdown from './dropdown.vue'
import device_categories from './device_categories.vue'
import devtypes from './devtypes.vue'
import materials from './materials.vue'
import documents from './documents.vue'
import workers from './workers.vue'
import collapsible from './collapsible.vue'
import criterium from './criterium.vue'
import popup from './popup.vue'
import tranches from './tranches.vue'
import register from './register.vue'
import remember from './remember.vue'
import imagemagnify from './imagemagnify.vue'
import reset_password from './reset_password.vue'
import login from './login.vue'
import select from './select.vue'
import itemorgroupselector from './itemorgroupselector.vue'
import selectdosages from './selectdosages.vue'
import zone_criterium from './zone_criterium.vue'
import editable from './editable.vue'
import Vue2Filters from 'vue2-filters'
import VueTagsInput from '@johmun/vue-tags-input';
import moment from 'moment'
import { _ } from 'vue-underscore';
import VueAppend from 'vue-append'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import TextareaAutosize from 'vue-textarea-autosize'
import draggable from 'vuedraggable'
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
import { InlineSvgPlugin } from 'vue-inline-svg';
import autotextarea from './autotextarea.vue'
import autosizelabel from './autosizelabel.vue'
import address from './address.vue'
import formatDate from './filters.js'
import VueTimepicker from 'vue2-timepicker'
import VueCookies from 'vue-cookies'

import 'vue2-timepicker/dist/VueTimepicker.css'
import pl from "./locales/pl.json";
import en from "./locales/en.json";
const messages = {
  en: en,
  pl: pl
}
Vue.use(VueCookies)
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: ( Cookies.get('lang') || navigator.language || navigator.userLanguage),
  fallbackLocale: 'pl',
  messages
})
Vue.$cookies.config('365d');
Vue.use(InlineSvgPlugin);
import VueObserveVisibility from 'vue-observe-visibility'
Vue.use(VueObserveVisibility)
Vue.use(require('vue-cookies'))
document.addEventListener('DOMContentLoaded', () => {
    var elems = document.querySelectorAll('select');
    var instances = M.FormSelect.init(elems, {});
    Vue.use(VueRouter)

    const routes = [
        { path: '/after-login', redirect: to => {
          if(window.app.app.role == 'ddd_customer') return 'places'
          else return 'desktop'
        }, },
        { path: '/desktop', component: desktop, name: "desktop", meta: {title: "Pulpit"} },
        { path: '/customers', component: customers, name: "customers", meta: {title: "Klienci"} },
        { path: '/customers/:customer_id', component: customer, name: "customer", meta: {title: "Klient"} },
        { path: '/places', component: places, name: "places", meta: {title: "Obiekty"} },
        { path: '/customers/:customer_id/places/:place_id', component: place, name: "place", meta: {title: "Obiekt"} },
        { path: '/customers/:customer_id/places/:place_id/inspections/:inspection_id', component: inspection, name: "inspection", meta: {title: "Karta kontroli"} },
        { path: '/customers/:customer_id/places/:place_id/inspections/:inspection_id/summary', component: inspection_summary, name: "inspection_summary", meta: {title: "Protokół kontroli"} },
        { path: '/customers/:customer_id/places/:place_id/inspections/:inspection_id/edit', component: inspection_edit, name: "inspectionedit", meta: {title: "Edycja kontroli"} },
        { path: '/customers/:customer_id/places/:place_id/inspections/:inspection_id/recommendations', component: placeinspectionrecommendations, name: "inspectionrecommendations", meta: {title: "Zalecenia do kontroli"} },
        { path: '/customers/:customer_id/places/:place_id/installations/:installation_id', component: installation, name: "installation", meta: {title: "Protokół wykonanych prac"} },
        { path: '/inspections', component: inspections, name: "inspections", meta: {title: "Kontrole"} },
        { path: '/installations', component: installations, name: "installations", meta: {title: "Montaże"} },
        { path: '/interventions', component: interventions, name: "interventions", meta: {title: "Interwencje"} },
        { path: '/protocols', component: protocols, name: "protocols", meta: {title: "Protokoły"} },
        { path: '/interventions/:intervention_id', component: intervention, name: "intervention", meta: {title: "Protokół interwencji"} },
        { path: '/tasks', component: tasks, name: "tasks", meta: {title: "Zadania"} },
        { path: '/bases', component: bases, name: "bases", meta: {title: "Bazy"} },
        { path: '/plantcare', component: plantcare, name: "plantcare", meta: {title: "Środki ochrony roślin"} },
        { path: '/settings', component: settings, name: "settings", meta: {title: "Ustawienia"} },
        { path: '/register', component: register, name: "register", meta: {title: "Rejestracja"} },
        { path: '/remember', component: remember, name: "remember", meta: {title: "Reset hasła"} },
        { path: '/login', component: login, name: "login", meta: {title: "Logowanie"} },
        { path: '/reset_password', component: reset_password, name: "reset_password", meta: {title: "Reset hasła"} },
    ]
    const DEFAULT_TITLE = "MOBIPest"
    const router = new VueRouter({
        routes // short for `routes: routes`
    })
    router.afterEach((to, from) => {
        Vue.nextTick(() => {
            document.title = to.meta.title || DEFAULT_TITLE;
        });
    });
    Chart.defaults.global.defaultFontStyle = 'bold';
    Chart.defaults.global.defaultFontColor = "#000";
    // Sentry.init({
    //   Vue,
    //   dsn: "https://148fb401eef24a2482a55d85278fbf07@o186527.ingest.sentry.io/1769123",
    //   integrations: [
    //     new BrowserTracing({
    //       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    //       tracingOrigins: ["stagging.mobipest.pl"],
    //     }),
    //   ],
    //   // Set tracesSampleRate to 1.0 to capture 100%
    //   // of transactions for performance monitoring.
    //   // We recommend adjusting this value in production
    //   tracesSampleRate: 1.0,
    // });
    Vue.directive('scroll', {
      inserted: function (el, binding) {
        let f = function (evt) {
          if (binding.value(evt, el)) {
            window.removeEventListener('scroll', f)
          }
        }
        window.addEventListener('scroll', f)
      }
    })
    const app = new Vue({
        i18n,
        render: h => h(App),
        router,
    }).$mount()
    

    console.log(document.getElementsByClassName('alert')[0].attributes['text'].value);
    console.log(document.getElementsByClassName('notice')[0].attributes['text'].value);
    document.body.appendChild(app.$el)
    Vue.component('autotextarea', autotextarea)
    Vue.component('autosizelabel', autosizelabel)
    Vue.component('addressfield', address)
    Vue.component('vue-tags-input', VueTagsInput)
    Vue.component('customers', customers)
    Vue.component('inspections', inspections)
    Vue.component('installations', installations)
    Vue.component('installation', installation)
    Vue.component('interventions', interventions)
    Vue.component('settings', settings)
    Vue.component('collapsible', collapsible)
    Vue.component('criterium', criterium)
    Vue.component('places', places)
    Vue.component('taskform', taskform)
    Vue.component('tasks', tasks)
    Vue.component('subplaces', subplaces)
    Vue.component('place', place)
    Vue.component('preloader', preloader)
    Vue.component('pest', pest)
    Vue.component('devices', devices)
    Vue.component('itemorgroupselector', itemorgroupselector)
    Vue.component('substance', substance)
    Vue.component('recommendationeditor', recommendationeditor)
    Vue.component('inspector', inspector)
    Vue.component('propertyproblemmodal', propertyproblemmodal)
    Vue.component('reporter', reporter)
    Vue.component('placeplans', placeplans)
    Vue.component('subdevices', subdevices)
    Vue.component('zone_criterium', zone_criterium)
    Vue.component('register', register)
    Vue.component('editable', editable)
    Vue.component('devtype', dev_type)
    Vue.component('dropdown', dropdown)
    Vue.component('worker', worker)
    Vue.component('calendar', calendar)
    Vue.component('devicecategory', device_category)
    Vue.component('material', material)
    Vue.component('tranches', tranches)
    Vue.component('pests', pests)
    Vue.component('targetpest', targetpest)
    Vue.component('substances', substances)
    Vue.component('devicecategories', device_categories)
    Vue.component('devtypes', devtypes)
    Vue.component('materials', materials)
    Vue.component('workers', workers)
    Vue.component('plantcare', plantcare)
    Vue.component('hamburger', hamburger)
    Vue.component('bases', bases)
    Vue.component('maintenaces', maintenaces)
    Vue.component('documents', documents)
    Vue.component('popup', popup)
    Vue.component('substancepopup', substancepopup)
    Vue.component('selector', select)
    Vue.component('selectpestquantities', selectpestquantities)
    Vue.component('selectpests', selectpests)
    Vue.component('selectdosages', selectdosages)
    Vue.component('dosageeditor', dosageEditor)
    Vue.component('desktop', desktop)
    Vue.component('week', week)
    Vue.component('day', day)
    Vue.component('modal', modal)
    Vue.component('line-chart', LineChart)
    Vue.component('pests-chart', PestsChart)
    Vue.component('percent-chart', PercentChart)
    Vue.component('col-chart', ColChart)
    Vue.component('col-chart-inspections', ColChartInspections)
    Vue.component('col-chart-inspections-quantities', ColChartInspectionsQuantities)
    Vue.component('avggraph', AvgGraph)
    Vue.component('stddgraph', StddGraph)
    Vue.component('devicegraph', DeviceGraph)
    Vue.component('sumgraphquantities', SumGraphQuantities)
    Vue.component('zonesinspectionsquantities', ZonesInspectionsQuantities)
    Vue.component('colchartzonesinspectionsquantities', ColChartZonesInspectionsQuantities)
    Vue.use(TextareaAutosize)
    Vue.component('draggable', draggable)
    Vue.component('date-range-picker', DateRangePicker)
    Vue.use(VueAppend)
    Vue.component('customer', customer)
    Vue.component('imagemagnify', imagemagnify)
    Vue.component('VueTimepicker', VueTimepicker)
    Vue.component('placeinspections', placeinspections)
    Vue.component('placeanalyses', placeanalyses)
    Vue.component('placeinstallations', placeinstallations)
    Vue.component('placeinterventions', placeinterventions)
    Vue.component('interventionmaterialedit', interventionmaterialedit)
    Vue.component('interventiondosageedit', interventiondosageedit)
    Vue.component('placerecommendations', placerecommendations)
    Vue.component('inspectionrecommendations', placerecommendations)
    Vue.component('v-lazy-image', VLazyImage)
    Vue.directive('init', {
        bind: function(el, binding, vnode) {
            vnode.context[binding.expression]();
        }
    });
    Vue.filter('formatDate', function(value) {
        if (value && moment(value).isValid()) {
            return moment(value).format('D.M.YYYY')
        }
    });

    Vue.filter('formatDateLong', function(value) {
        if (value && moment(value).isValid()) {
            return moment(value).format('D MMMM YYYY')
        }
    });

    Vue.filter('truncate', function(text, length, suffix) {
        if (text.length > length) {
            return text.substring(0, length) + suffix;
        } else {
            return text;
        }
    });
    Vue.filter('formatDateMonth', function(value) {
        if (value && moment(value).isValid()) {
            return moment(value).format('MMMM YYYY')
        }
    });
    Vue.filter('formattimestamp', function(value) {
        if (value && moment(value).isValid()) {
            return ""+moment(value).unix();
        }
    });
    Vue.filter('formatDateMinuses', function(value) {
        if (value) {
            return moment(value).format('D-M-YYYY')
        }
    });
    Vue.filter('formatDateWithHour', function(value) {
        if (value) {
            return moment(value).format('D.M.YYYY HH:mm')
        }
    });
    Vue.filter('formatDateWithHourSeconds', function(value) {
        if (value) {
            return moment(value).format('D.M.YYYY HH:mm:ss')
        }
    });
    Vue.filter('formatHour', function(value) {
        if (value) {
            return moment(value).format('HH:mm')
        }
    });
    Vue.filter('formatHourSeconds', function(value) {
        if (value) {
            return moment(value).format('HH:mm:ss')
        }
    });
    Vue.filter('extractMinutes', function(value) {
        if (value) {
            return moment(value).format('H')
        }
    });
    Vue.filter('formatExtractHour', function(value) {
        if (value) {
            return moment(value).format('HH')
        }
    });
    Vue.filter('nameTypes', function(value, otherval) {
        if (value) {
            return value.map(x => {
                if (x == "other") {
                    return otherval || 'Inne'
                } else {
                    return { 'deratization': "Deratyzacja", "disinfection": "Dezynfekcja", "disinsection": "Dezynsekcja" } [x];
                }
            }).join(", ")
        }
    });
    Vue.filter('tobase64', function(value) {
        return "data:image/svg+xml;base64,"+window.btoa(window.unescape(encodeURIComponent(value)));
    });
    Vue.filter('nameTaskType', function(value) {
        return { 'inspection': "Kontrola punktów monitorowania", "intervention": "Zabieg interwencyjny", "installation": "Montaż punktów monitorowania", "other": "Inne" } [value];
    });
    Vue.filter('nameByIds', function(value, collection) {
        return _.uniq(value).map(x => {
            var who = _.find(collection, { id: x });
            if (_.isUndefined(who) == false) return who.name + " " + who.surname;
        }).join(", ")
    });
    Vue.filter('joinComma', function(collection) {
        return collection.join(", ")
    });
    Vue.filter('format_number', function (value){
      return parseInt(value).toLocaleString()
    });
    Vue.filter('orderingCustomized', function(value, collection, ordering) {
        return [];
    });
    Vue.filter('getTaskWeekText', function(value) {
        if (value) {
            var ttypes = { 'inspection': "Kontrola", "intervention": "Interwencja", "installation": "Montaż", "other": value.typeof_other }
            var dtypes = { 'deratization': "Deratyzacja", "disinfection": "Dezynfekcja", "disinsection": "Dezynsekcja", "other": value.intervention_type_other, "undefined": "Interwencja" }
            var typ = ttypes[value.kind];
            if (value.kind == 'intervention') typ = dtypes[value.intervention_type]
            return moment(value.startsAt).format('HH:mm') + "-" + moment(value.endsAt).format('HH:mm') + " " + typ
        }
    });
    Vue.use(Vue2Filters)
    Vue.directive('collapsible', {
        inserted: function() {
            var elems = document.querySelectorAll('.collapsible');
            var instances = M.Collapsible.init(elems, { accordion: false });
        }
    });

})
window.median = function(array) {
        array.sort((a, b) => b - a);
        const length = array.length;
        if (length % 2 == 0) {
            return (array[length / 2] + array[(length / 2) - 1]) / 2;
        } else {
            return array[Math.floor(length / 2)];
        }
    },
    _.diff = function(object, base) {
        function changes(object, base) {
            return _.transform(object, function(result, value, key) {
                if (!_.isEqual(value, base[key])) {
                    result[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;
                }
            });
        }
        return changes(object, base);
    }
